/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100143 単価マスタ出力
 */
import { Box } from "@mui/material";
import {
  B000200JanShohinNmFrom,
  B000200JanShohinNmTo,
  B000200ShohinNmFrom,
  B000200ShohinNmTo,
  B100143ExcelRequest,
  B100143GetExcel,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  B100143TankaKbn,
  getSCode,
  HachuUchiwakeKbn,
  SCode,
} from "messages/codes";
import { labels } from "messages/labels";
import { B000200 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  tankaKbn: SCode;
  shohinCdFrom: string;
  shohinNmFrom: string;
  shohinCdTo: string;
  shohinNmTo: string;
  janCdFrom: string;
  janShohinNmFrom: string;
  janCdTo: string;
  janShohinNmTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  tankaKbn: getSCode(B100143TankaKbn, "0"),
  shohinCdFrom: "",
  shohinNmFrom: "",
  shohinCdTo: "",
  shohinNmTo: "",
  janCdFrom: "",
  janShohinNmFrom: "",
  janCdTo: "",
  janShohinNmTo: "",
};

const focusId = "B100143";

export const B100143 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100143ExcelRequest = {
      tankaKbn: fields.tankaKbn?.value,
      shohinCdFrom: fields.shohinCdFrom!,
      shohinCdTo: fields.shohinCdTo!,
      janCdFrom: fields.janCdFrom!,
      janCdTo: fields.janCdTo!,
    };

    B100143GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100143_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="単価マスタ出力"
        gridTemplateColumns="7rem 10rem 18rem 1rem 10rem 18rem "
      >
        <SText gridColumn="span 7">　</SText>

        <SText gridColumn="span 7">　</SText>

        <SLabel gridColumn="1" required>
          単価区分
        </SLabel>
        <SCodeSelect
          label="単価区分"
          name="tankaKbn"
          required
          options={B100143TankaKbn}
          {...register(1)}
        />

        <SText gridColumn="span 7">　</SText>

        <SLabel gridColumn="1" required>
          商品コード
        </SLabel>
        <SNumberField
          label="商品コード(開始)"
          name="shohinCdFrom"
          size={10}
          {...register(2)}
          onBlur={() => B000200ShohinNmFrom(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCdFrom", data.shohinCd);
            methods.setValue("shohinNmFrom", data.shohinNm);
          }}
          code
          required
        />
        <STextField name="shohinNmFrom" size={20} disabled />
        <SText>～</SText>
        <SNumberField
          label="商品コード(終了)"
          name="shohinCdTo"
          size={10}
          {...register(3)}
          onBlur={() => B000200ShohinNmTo(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCdTo", data.shohinCd);
            methods.setValue("shohinNmTo", data.shohinNm);
          }}
          code
        />
        <STextField name="shohinNmTo" size={20} disabled />

        <SLabel gridColumn="1">JANコード</SLabel>
        <SNumberField
          name="janCdFrom"
          size={13}
          {...register(4)}
          onBlur={() => B000200JanShohinNmFrom(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("janCdFrom", data.janCd);
            methods.setValue("janShohinNmFrom", data.shohinNm);
          }}
          code
        />
        <STextField name="janShohinNmFrom" size={20} disabled />
        <SText>～</SText>
        <SNumberField
          name="janCdTo"
          size={13}
          {...register(5)}
          onBlur={() => B000200JanShohinNmTo(methods, navigate, setMsg)}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("janCdTo", data.janCd);
            methods.setValue("janShohinNmTo", data.shohinNm);
          }}
          code
        />
        <STextField name="janShohinNmTo" size={20} disabled />
        <Box />

        <Box gridColumn="span 5" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(6)}
          dialog={
            <SConfirmDialog
              title="単価マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
